import { TypePolicies } from '@apollo/client';

export const typePolicies: TypePolicies = {
  ContractType: {
    keyFields: ['contractID'],
  },
  CustomerType: {
    keyFields: ['customerID'],
  },
  ContractLineByBillingCyclesType: {
    keyFields: ['contractLineID'],
  },
  ChangeSetType: {
    keyFields: ['changeSetID'],
  },
  ReasonCodeType: {
    keyFields: ['code', 'name'],
  },
  ReasonType: {
    keyFields: ['type'],
  },
  CurrencyType: {
    keyFields: ['currency']
  },
  RenewalSettingsType: {
    keyFields: ['billingInterval']
  },
  DirectDebitType: {
    keyFields: ['type']
  },
  ClientDatabases: {
    keyFields: ['iD']
  },
  User: {
    keyFields: ['id']
  },
  SearchTagType: {
    keyFields: ['tagId']
  },
  ContractNoteType: {
    keyFields: ['contractNoteID']
  },
  UsageHeaderOutput: {
    keyFields: ['iD']
  },
  VarBillingUsageDetailOutput: {
    keyFields: ['usageDetailID']
  }
};
